import { useMutation } from "@tanstack/react-query";
import { updateSplashTimeout } from "../../api/tplinkApi";

export const useUpdateTPLinkSplashTimeout = () => {
  return useMutation({
    mutationFn: (data) => updateSplashTimeout(data),
    onSuccess: (response) => {
      console.log("TP-Link splash timeout updated successfully:", response.data);
    },
    onError: (error) => {
      console.error("Error updating TP-Link splash timeout:", error);
    },
  });
};
